var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeatureNotAvailable = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 58,
    viewBox: "0 0 70 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427318145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.1126 3.08287L68.2378 47.7211C68.3436 48.6423 67.685 49.4839 66.7584 49.5909L7.74889 56.4062C6.82234 56.5132 5.99082 55.8478 5.88458 54.9225L1.68349 18.3328C1.57772 17.4116 2.2362 16.57 3.16276 16.4629L37.3487 12.5147C38.106 12.4272 38.8009 12.0439 39.2785 11.4402L44.5078 4.83042C45.2314 3.91578 46.29 3.32269 47.4421 3.18962L61.2517 1.59468C62.1783 1.48767 63.0099 2.15311 63.1162 3.07836L63.1126 3.08287Z",
    stroke: "#071A24",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.4383 3.19352C46.2821 3.32705 45.2271 3.91563 44.5039 4.83432L39.2747 11.4441C38.797 12.0478 38.1062 12.4306 37.3448 12.5186L24.655 13.9842C25.4124 13.8967 26.1072 13.5134 26.5849 12.9097L31.8141 6.29992C32.5377 5.38528 33.5963 4.79219 34.7485 4.65912L47.4383 3.19352Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.6588 32.4668L26.5945 24.1913C26.3772 22.4765 27.5998 20.8942 29.3101 20.6803L35.707 19.8678C37.4168 19.6499 38.9944 20.876 39.2077 22.5913L40.2065 30.5083",
    stroke: "#071A24",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.7298 28.6995L40.0731 29.4183L21.7989 31.7336C21.0143 31.8324 20.4601 32.5515 20.5626 33.338L22.1902 46.2343C22.2887 47.0212 23.0057 47.5771 23.7858 47.4747L47.7132 44.4451C48.4978 44.3463 49.052 43.6273 48.9499 42.8448L47.3259 29.944C47.2274 29.1571 46.5104 28.6012 45.7303 28.7035L45.7298 28.6995ZM36.0526 34.6808L36.8585 41.0603C36.9182 41.5447 36.5734 41.9898 36.0909 42.0537L34.4496 42.2638C33.9666 42.3236 33.5228 41.9778 33.4631 41.4934L32.6571 35.1139C32.5974 34.6296 32.9423 34.1844 33.4248 34.1205L35.0661 33.9105C35.549 33.8506 35.9929 34.1964 36.0526 34.6808Z",
    fill: "#071A24"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeatureNotAvailable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feature_not_available.f7880a9e1844465308be9c37bc90ce26.svg";